import React from 'react';
import { Tooltip, Icon  } from "@wordpress/components"
import { help } from '@wordpress/icons';

export const LinkGeniusTooltip = ({ text }) => {
    return (
        <Tooltip text={text}>
            <span><Icon icon={help} className="help" /></span>
        </Tooltip>
    );
}